import { View } from "react-native";
import StyledText from "../../../common/ui/styled-text";

interface SettingsCardProps {
  title?: string;
  titleComponent?: React.ReactNode;
  children: React.ReactNode;
  noSpacing?: boolean;
  className?: string;
  innerClassName?: string;
}

export default function SettingsCard({
  title,
  titleComponent,
  children,
  noSpacing = false,
  className,
  innerClassName,
}: SettingsCardProps) {
  return (
    <View className={className}>
      {title && (
        <StyledText className="text-lg font-semibold mb-2 ml-1">
          {title}
        </StyledText>
      )}
      <View
        className={`px-3 py-5 sm:py-5 sm:px-5 bg-white rounded-xl shadow-sm border border-gray-100 ${innerClassName}`}
      >
        {/* {title && <StyledText className="text-2xl font-semibold mb-6">{title}</StyledText>} */}
        {titleComponent && titleComponent}
        <View className={`${noSpacing ? "" : "space-y-10"}`}>{children}</View>
      </View>
    </View>
  );
}
